export default "__VITE_ASSET__2b802793__"